/**
 * @description 应用服务配置 appServiceConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const appServiceConfigBiz = new Logic()

appServiceConfigBiz.deleteService = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.deleteService,
    data: data
  })
}

appServiceConfigBiz.getService = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.getService,
    data: data
  })
}

appServiceConfigBiz.updateService = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.updateService,
    data: data
  })
}

appServiceConfigBiz.getAppStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.getAppStatus,
    data: data
  })
}

appServiceConfigBiz.deleteMulService = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.deleteMulService,
    data: data
  })
}

appServiceConfigBiz.getNodeGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.getNodeGroup,
    data: data
  })
}

appServiceConfigBiz.getNodeInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.getNodeInfo,
    data: data
  })
}

appServiceConfigBiz.batchAmendLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appServiceConfig.batchAmendLog,
    data: data
  })
}

export default appServiceConfigBiz
